exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".NoScrollLayout-2697ff96{position:absolute;top:0;right:0;bottom:0;left:0;max-height:100vh;overflow:hidden;display:flex;flex-direction:column;justify-content:stretch}.NoScrollLayout-2697ff96 .content-47b607bc{flex:1;position:relative;min-height:0}\n", ""]);

// Exports
exports.locals = {
	"NoScrollLayout": "NoScrollLayout-2697ff96",
	"content": "content-47b607bc"
};